import styled from 'styled-components';

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
`;

export { Container };
